export default __webpack_public_path__ + "static/media/body_6.b4e41f77.png";